import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { People, PerformanceGoalControllerClient } from '~/services/Http';

export const GET_EMPLOYEE_PERFORMANCE_SCORE_SWR_KEY =
  'PerformanceGoalControllerClient.useGetEmployeePerformanceScores';

export function useGetEmployeePerformanceScores(args: {
  employeeId: string;
  lang?: string;
}): UseSWROutput<People.PerformanceGoalFullDto> {
  return useSWR(
    [
      GET_EMPLOYEE_PERFORMANCE_SCORE_SWR_KEY,
      args.employeeId,
      args?.lang ?? undefined,
    ],
    ([_, employeeId, lang]) =>
      PerformanceGoalControllerClient.getEmployeeCurrentPerformanceGoal(
        employeeId,
        lang,
      ).then((r) => r.data),
  );
}
